import { CLINICS_GET_MARGINS, RETRIEVE_EXAMS_DELIVERY_TIME_REQUEST,
  RETRIEVE_EXAMS_DELIVERY_TIME_SUCCESS, RETRIEVE_EXAMS_DELIVERY_TIME_FAILURE,
  CLINICS_LIST_REQUEST, CLINICS_LIST_SUCCESS, CLINICS_LIST_FAILURE } from '../actions/clinics';

const initialState = {
  list: [],
  clinicsLoading: false,
  clinicsLoadingError: null,
  clinics_map: {},
  categories: {},
  clinicsUrgentCategoryId: {},
  currentMargins: null,
  users: {},
  retrievingExamsDeliveryTime: false,
  examsDeliveryTime: {},
  examsDeliveryTimeError: null,
};

const clinics = (state = initialState, action) => {
  switch (action.type) {
    case CLINICS_LIST_REQUEST:
      return {
        ...state,
        clinicsLoading: true,
      };
    case CLINICS_LIST_SUCCESS:
      return {
        ...state,
        clinicsLoading: false,
        list: action.data,
        clinics_map: createClinicMap(action.data),
        categories: createCategoriesMap(action.data),
        clinicsUrgentCategoryId: createClinicsUrgentCategoryIdMap(action.data),
        users: createUsersMap(action.data),
      };
    case CLINICS_LIST_FAILURE:
      return {
        ...state,
        clinicsLoading: false,
        clinicsLoadingError: action.data,
      };
    case CLINICS_GET_MARGINS:
      return {
        ...state,
        currentMargins: action.data,
      };
    case RETRIEVE_EXAMS_DELIVERY_TIME_REQUEST:
      return {
        ...state,
        retrievingExamsDeliveryTime: true,
      };
    case RETRIEVE_EXAMS_DELIVERY_TIME_SUCCESS:
      return {
        ...state,
        retrievingExamsDeliveryTime: false,
        examsDeliveryTime: action.data,
      };
    case RETRIEVE_EXAMS_DELIVERY_TIME_FAILURE:
      return {
        ...state,
        retrievingExamsDeliveryTime: false,
        examsDeliveryTimeError: action.data,
      };
    default:
      return state;
  }
};

function createCategoriesMap(clinics) {
  const result = {};
  clinics.forEach((c) => {
    if (!c.profile) return;
    c.profile.exam_categories.forEach((category) => {
      if (!(category.id in result)) {
        result[category.id] = category;
      }
    });
  });
  return result;
}

function createClinicsUrgentCategoryIdMap(clinics) {
  const result = {};
  clinics.forEach((c) => {
    if (!c.profile) return;
    c.profile.exam_categories.forEach((category) => {
      if (category.name === 'URGÊNCIA') {
        result[c.id] = category;
      }
    });
  });
  return result;
}

function createClinicMap(clinics) {
  const result = {};
  clinics.forEach((c) => {
    result[c.id] = c;
  });
  return result;
}

function createUsersMap(clinics) {
  const result = {};
  clinics.forEach((c) => {
    c.members.forEach((member) => {
      result[member.id] = member;
    });
  });
  return result;
}

export default clinics;
